import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const competencies = [
  {
    number: "01",
    name: "Data Science",
    desc:
      "Build capability across data exploration, modelling and business decision-making.",
    type: "data science",
  },
  {
    number: "02",
    name: "Product Marketing",
    desc:
      "Help teams connect customer insight, positioning and measurable product growth.",
    type: "product marketing",
  },
  {
    number: "03",
    name: "Project Management",
    desc:
      "Strengthen planning, delivery, stakeholder alignment and accountable execution.",
    type: "project management",
  },
  {
    number: "04",
    name: "Product Management",
    desc:
      "Develop stronger product judgement from discovery through delivery and iteration.",
    type: "product management",
  },
  {
    number: "05",
    name: "Software Engineering",
    desc:
      "Build modern technical capability through practical, project-led development.",
    type: "software engineering",
  },
  {
    number: "06",
    name: "Cybersecurity",
    desc:
      "Equip teams to understand risk, controls and responsible security operations.",
    type: "cybersecurity",
  },
  {
    number: "07",
    name: "AI & Automation",
    desc:
      "Identify and build responsible AI workflows that improve productivity and operations.",
    type: null,
  },
  {
    number: "08",
    name: "Cloud & DevOps",
    desc:
      "Develop the infrastructure skills behind resilient modern digital products.",
    type: null,
  },
];

const DigitalCompetencies = () => {
  return (
    <section
      className="py-16 md:py-20 lg:py-24 px-4"
      id="competencies"
      style={{ background: "#fdf2df" }}
    >
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Core digital competencies
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-2xl tracking-[-0.03em] text-primary">
              Choose the capability your organisation needs to build.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              Start with a proven pathway, then adapt the level, projects and
              business context to your people.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
          {competencies.map((competency) => (
            <Animate.Fade bottom key={competency.number}>
              <article
                className="h-full flex flex-col rounded-2xl p-7 bg-white shadow-course-card"
                style={{ minHeight: "260px" }}
              >
                <span className="text-[#8e5e00] font-poppins text-xs font-extrabold tracking-widest">
                  {competency.number}
                </span>
                <h3 className="font-poppins font-bold text-xl text-primary mt-5 mb-3">
                  {competency.name}
                </h3>
                <p className="text-gray font-poppins text-sm leading-relaxed flex-1">
                  {competency.desc}
                </p>
                <Link
                  to={
                    competency.type
                      ? `/business/courses?type=${encodeURI(competency.type)}`
                      : "/business/courses"
                  }
                  className="mt-6 font-poppins font-extrabold text-primary text-sm flex items-center gap-2 hover:text-secondary transition-colors"
                >
                  View pathway
                  <ArrowUpRight className="w-3 h-3" />
                </Link>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DigitalCompetencies;
